// SLA Leasehold Table ("Bala's Table") — leasehold value as a percentage of
// freehold value by remaining lease term (years). Source: SLA, reproduced in
// CLC commentary "Determining the value of leasehold land: A closer look at
// Bala's Table" (Appendix 1). The implicit discount rate is ~3.5%.
// https://isomer-user-content.by.gov.sg/50/ade6cd16-890b-4a1b-9d1d-d0e189daba03/balas-table.pdf
export const BALA_TABLE: Record<number, number> = {
  1: 3.8, 2: 7.5, 3: 10.9, 4: 14.1, 5: 17.1, 6: 19.9, 7: 22.7, 8: 25.2, 9: 27.7, 10: 30.0,
  11: 32.2, 12: 34.3, 13: 36.3, 14: 38.2, 15: 40.0, 16: 41.8, 17: 43.4, 18: 45.0, 19: 46.6, 20: 48.0,
  21: 49.5, 22: 50.8, 23: 52.1, 24: 53.4, 25: 54.6, 26: 55.8, 27: 56.9, 28: 58.0, 29: 59.0, 30: 60.0,
  31: 61.0, 32: 61.9, 33: 62.8, 34: 63.7, 35: 64.6, 36: 65.4, 37: 66.2, 38: 67.0, 39: 67.7, 40: 68.5,
  41: 69.2, 42: 69.8, 43: 70.5, 44: 71.2, 45: 71.8, 46: 72.4, 47: 73.0, 48: 73.6, 49: 74.1, 50: 74.7,
  51: 75.2, 52: 75.7, 53: 76.2, 54: 76.7, 55: 77.3, 56: 77.9, 57: 78.5, 58: 79.0, 59: 79.5, 60: 80.0,
  61: 80.6, 62: 81.2, 63: 81.8, 64: 82.4, 65: 83.0, 66: 83.6, 67: 84.2, 68: 84.5, 69: 85.4, 70: 86.0,
  71: 86.5, 72: 87.0, 73: 87.5, 74: 88.0, 75: 88.5, 76: 89.0, 77: 89.5, 78: 90.0, 79: 90.5, 80: 91.0,
  81: 91.4, 82: 91.8, 83: 92.2, 84: 92.6, 85: 92.9, 86: 93.3, 87: 93.6, 88: 94.0, 89: 94.3, 90: 94.6,
  91: 94.8, 92: 95.0, 93: 95.2, 94: 95.4, 95: 95.6, 96: 95.7, 97: 95.8, 98: 95.9, 99: 96.0,
};

/** % of freehold value for a remaining lease term (clamped to 0–99 years). */
export function balaPercent(remainingYears: number): number {
  if (remainingYears <= 0) return 0;
  const y = Math.min(99, Math.round(remainingYears));
  return BALA_TABLE[Math.max(1, y)] ?? 0;
}

/**
 * Cumulative depreciation % (vs an identical brand-new 99-year project) for a
 * project of the given age, per Bala's Table:
 *   value ratio = bala(99 - age) / bala(99)
 */
export function balaDepreciationPct(ageYears: number): number {
  const remaining = Math.max(0, 99 - ageYears);
  const ratio = balaPercent(remaining) / balaPercent(99);
  return Math.max(0, Math.min(99, (1 - ratio) * 100));
}
